import React from 'react';
import Modal from '../../../components/Modal';
import MasterDataService from '../../../services/master-data';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import message from '../../../constant/message';
import { objectsForEach } from '../../../common/objectToArray';
import Button from '../../../components/Common/Button';
import { useNavigate } from 'react-router';

const DirectSanctionToLender = ({ detailLenderName, detailLenderId, modelState, toggleModal }) => {
    const { state } = React.useContext(Context);
    const [comment, setComment] = React.useState('');
    const [errors, setErrors] = React.useState({});
    const [submitLoading, setSubmitLoading] = React.useState(false);
    const leadId = useParams()['id'];
    const navigate = useNavigate();
    
    
    const savePreapprovedLenderLead = async () => {
        try {
            setSubmitLoading(true);
            const response = await MasterDataService.savePreapprovedLenderLead(
                state.userType,
                'co-lender',
                leadId,
                detailLenderId,
                comment
            );

            if (response?.data?.status?.code === 1) {
                const success = response?.data?.messages?.success;
                toast.success(
                    success?.form?.[0] || success?.others?.[0] || message.SAVED_SUCCESS
                );
                toggleModal();
            }
            setSubmitLoading(false);
            redirectToDetails();
        } catch (err) {
            setSubmitLoading(false);
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM);
            setErrors(error);
        }
    };

    const redirectToDetails = () => {
        navigate('/portfolio/assigned/');
    };

    const formSubmitHandler = (e) => {
        e.preventDefault();
        if (!submitLoading) {
            savePreapprovedLenderLead();
        }
    };

    return (
        <Modal state={modelState} closeModal={toggleModal} removeBorderSpace={true} closeOnOverlayClick={false}>
            <div className="modal-header-container">
                <div className="modal-title">Final Submit To Lender</div>
                <div className="closeModalView">
                    <span className="closeModalIcon" onClick={toggleModal}>x</span>
                </div>
            </div>
            <div className="p-4">
                <div>
                    <p className='font-weight-bold text-center'>
                        Is the Sanction received from{' '}
                        {detailLenderName}?
                    </p>
                    <div className='d-flex align-items-center justify-content-center'>
                        <Button
                            clickHandler={toggleModal}
                            classNames='btn-custom small mr-2'
                        >
                            No
                        </Button>
                        <Button
                            clickHandler={formSubmitHandler}
                            disabled={submitLoading}
                            classNames='btn-custom small'
                        >
                            {submitLoading ? <div className='loader' /> : 'Yes'}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DirectSanctionToLender;
